export default __webpack_public_path__ + "static/future-99d05d755b9b7ef48e84d1f31714ffe0.svg";